import React from 'react';
import { EllipsisDot, LoginButtonLoaderContainer } from './style';

const LoginButtonLoader = () => {
  return (
    <>
      <LoginButtonLoaderContainer>
        <EllipsisDot color='var(--loader-login-button-Ellipsis-dot-color)' />
        <EllipsisDot color='var(--loader-login-button-Ellipsis-dot-color)' />
        <EllipsisDot color='var(--loader-login-button-Ellipsis-dot-color)' />
        <EllipsisDot color='var(--loader-login-button-Ellipsis-dot-color)' />
      </LoginButtonLoaderContainer>
    </>
  );
};

export default LoginButtonLoader;
